'use client';

import { useEffect, useState } from 'react';
import { CredentialResponse, GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useTurnkey } from '@turnkey/sdk-react';
import { sha256 } from 'viem';
import { Skeleton } from '../ui/skeleton';
import { useTurnKeyAuth } from '@/hooks/auth/turnkey/useTurnKeyAuth';
const GoogleAuth = () => {
  const {
    authIframeClient
  } = useTurnkey();
  const clientId = process.env.NEXT_PUBLIC_GOOGLE_OAUTH_CLIENT_ID;
  const [nonce, setNonce] = useState('');
  const {
    loginWithGoogle
  } = useTurnKeyAuth();
  useEffect(() => {
    if (authIframeClient?.iframePublicKey) {
      const hashedPublicKey = sha256(authIframeClient.iframePublicKey as `0x${string}`).replace(/^0x/, '');
      setNonce(hashedPublicKey);
    }
  }, [authIframeClient?.iframePublicKey]);
  const onSuccess = async (credentialResponse: CredentialResponse) => {
    if (credentialResponse.credential) {
      loginWithGoogle(credentialResponse.credential as string);
    }
  };
  return <GoogleOAuthProvider clientId={clientId} data-sentry-element="GoogleOAuthProvider" data-sentry-component="GoogleAuth" data-sentry-source-file="turnKeyGoogleAuth.tsx">
      {nonce ? <GoogleLogin nonce={nonce} containerProps={{
      className: 'w-[356px] mt-2 rounded-full bg-genius-pink text-genius-indigo transition-all duration-300 h-[56px] relative'
    }} onSuccess={onSuccess} useOneTap={false} auto_select={false} /> : <Skeleton className='h-10 w-full' />}
    </GoogleOAuthProvider>;
};
export default GoogleAuth;